import dayjs from "dayjs";

const calendarParts = (value) => {
  if (!value) return null;
  const date = dayjs.isDayjs(value) ? value : dayjs(value);
  if (!date.isValid()) return null;
  const year = date.year();
  const month = date.month() + 1;
  const day = date.date();
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [rawYear, rawMonth, rawDay] = value.split("-").map(Number);
    if (year !== rawYear || month !== rawMonth || day !== rawDay) return null;
  }
  return { year, month, day };
};

export const calculateAgeYears = (birthValue, attentionValue) => {
  const birth = calendarParts(birthValue);
  const attention = calendarParts(attentionValue || dayjs());
  if (!birth || !attention) return null;
  let age = attention.year - birth.year;
  if (attention.month < birth.month || (attention.month === birth.month && attention.day < birth.day)) {
    age -= 1;
  }
  return age >= 0 ? age : null;
};

const DAYS = 30;
const BLISTERS = 9;
const TABLETS_PER_BLISTER = 10;
const supplement = (name) =>
  `${name}: ${BLISTERS} blísteres de ${TABLETS_PER_BLISTER} tabletas (${BLISTERS * TABLETS_PER_BLISTER} tabletas equivalentes)`;

export const TREATMENT_SCHEMES = {
  mam: {
    title: "Desnutrición aguda moderada - MAM",
    items: [`RUTF: 1 sobre diario durante ${DAYS} días (${1 * DAYS} sobres previstos)`, "Kit de Higiene Inicial", "Ecofiltro"],
  },
  sam: {
    title: "Desnutrición aguda severa - SAM",
    items: [`RUTF: 2 sobres diarios durante ${DAYS} días (${2 * DAYS} sobres previstos)`, "Kit de Higiene Inicial", "Ecofiltro"],
  },
  melAdequate: {
    title: "MEL - Peso adecuado",
    items: [
      supplement("Ácido fólico 10 mg"),
      supplement("Sulfato ferroso 300 mg"),
    ],
  },
  melLow: {
    title: "MEL - Bajo peso",
    items: [
      `Plumpy Doz: 1 sobre diario durante ${DAYS} días (${1 * DAYS} sobres previstos)`,
      supplement("Ácido fólico 10 mg"),
      supplement("Sulfato ferroso 300 mg"),
    ],
  },
};
